<template>
  <Popover
    trigger="hover"
    width="200"
  >
    <div
      v-for="(item, index) in dataSource"
      :key="index"
    >
      <div class="desc-title">
        {{ item.title }}
      </div>
      <div
        class="desc-content"
        v-html="item.content"
      />
    </div>
    <slot slot="reference" />
  </Popover>
</template>

<script>
import { Popover } from 'element-ui';

export default {
  components: {
    Popover,
  },

  props: {
    dataSource: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="less" scoped>
.desc {
  &-title {
    font-weight: bold;
    margin-bottom: 10px;
  }

  &-content {
    margin-bottom: 20px;
  }
}
</style>
